import styled from 'styled-components';

export const InvoiceContainer = styled.div`
  font-family: Arial, sans-serif;
  color: #333;
  padding: 2rem;
  max-width: 800px;
  margin: 0 auto;
  background: #fff;
  border: 1px solid #ddd;
  position: relative;

  @media print {
    body * {
      visibility: hidden;
    }

    & {
      visibility: visible;
    }

    img {
      max-width: 100%;
      height: auto;
    }

    button {
      display: none;
    }

    table {
      border-collapse: collapse;
      width: 100%;
    }

    th,
    td {
      border: 1px solid #ddd;
      padding: 8px;
      text-align: left;
    }
  }
`;

export const Header = styled.div`
  align-self: center;
  h1 {
    font-size: 2rem;
    color: #000;
  }
  p {
    padding-top: 5px;
    text-align: center;
  }
  img {
    height: 50px;
  }
`;

export const CompanyInfo = styled.div`
  margin: 1rem 0;

  p {
    margin: 0.5rem 0;
    font-size: 0.9rem;
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: 1rem 0;
`;

export const TableRow = styled.tr``;

export const TableHeader = styled.th`
  text-align: left;
  padding: 0.5rem;
  background: #f5f5f5;
  border: 1px solid #ddd;
`;

export const TableData = styled.td`
  padding: 0.5rem;
  border: 1px solid #ddd;
`;

export const InvoiceDetails = styled.div`
  text-align: right;
  margin-top: 1rem;

  p {
    margin: 0.3rem 0;
    font-size: 0.9rem;
  }
`;

export const PaymentInfo = styled.div`
  margin: 1rem 0;

  p {
    margin: 0.5rem 0;
    font-size: 0.9rem;
  }
`;

export const Divider = styled.div`
  position: relative;
  margin: 2rem 0;
  height: 1.5px;
  background: none;
  border-top: 1.5px dashed #000;

  &::before {
    content: '✂️';
    position: absolute;
    top: -22px;
    left: 0;
    transform: translateX(-50%);
    rotate: -80deg;
    background: #fff;
    padding: 0 0.2rem;
  }
`;

export const PaymentAdvice = styled.div`
  display: grid;
  grid-auto-flow: column;
  justify-content: space-between;

  h2 {
    font-size: 1.2rem;
    margin-bottom: 1rem;
  }

  p {
    margin: 0.5rem 0;
    font-size: 0.9rem;
  }
`;

export const LogoImg = styled.img`
  width: 260px;
  height: 80px !important;
  margin-left: -12px;
`;

export const HeaderWrapper = styled.div`
  display: grid;
  grid-auto-flow: column;
  justify-content: space-between;
`;

export const TextWrapper = styled.div`
  display: flex;
  gap: 20px;
  padding-top: 5px;
`;
